import { Typography } from '@mui/material'
import { BulkActionWrapperDialogProps, BulkActionDialog } from 'components/core/bulk-actions/BulkActionDialog'
import { AppEntitlementUserBindingSearchFilter, AppEntitlementWithExpired } from 'pbts/c1/api/app/v1/app_entitlement'
import { FC } from 'react'
import { FormattedMessage } from 'react-intl'

export const BulkRemoveGrantDurationDialog: FC<BulkActionWrapperDialogProps<AppEntitlementWithExpired>> = (
    { close, selections, setSelections, triggerFetchActionStatus },
) => {
    return (
        <BulkActionDialog<AppEntitlementWithExpired>
            close={close}
            args={{
                oneofKind: 'removeGrantExpirationAction',
                removeGrantExpirationAction: {
                    filter: AppEntitlementUserBindingSearchFilter.create({
                        refs: selections.map((appEntWithExpired) => ({
                            appId: appEntWithExpired.appId,
                            appEntitlementId: appEntWithExpired.appEntitlementId,
                            appUserId: appEntWithExpired.appUserId,
                        })),
                    }),
                },
            }}
            selections={selections}
            setSelections={setSelections}
            title={<FormattedMessage
                id="bulk_action_remove_grant_duration_title"
                defaultMessage="Remove expiration for {count} {count, plural, one {grant} other {grants}}"
                values={{ count: selections.length }}
            />}
            submitButtonText={<FormattedMessage id="bulk_action_remove_grant_duration_submit" defaultMessage="Remove" />}
            triggerFetchActionStatus={triggerFetchActionStatus}
        >
            <Typography>
                <FormattedMessage
                    id="bulk_remove_grant_duration_confirmation"
                    defaultMessage="Are you sure you want to remove the expiration date from the selected grants? This will make them permanent until manually revoked."
                />
            </Typography>
        </BulkActionDialog>
    )
}
